import { useParams, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

const API_BASE = "https://api.mariamlyluxe.com/public";

export default function BrandDetailsPage() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [brand, setBrand] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        // إذا عندك API للبراند بالـ slug بدّلوه هون
        const r = await fetch(`${API_BASE}/api/brands?slug=${encodeURIComponent(slug)}`, { headers: { Accept: "application/json" } });
        if (!r.ok) throw new Error(`Failed: ${r.status}`);
        const j = await r.json();
        const b = Array.isArray(j?.brands) ? j.brands[0] : null;
        setBrand(b);
      } catch (e) {
        setError("Brand not found.");
        console.warn(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  if (loading) return <p>Loading brand…</p>;
  if (error || !brand) return <p style={{ color: "crimson" }}>{error || "Not found."}</p>;

  return (
    <section>
      <button onClick={() => nav(-1)} style={{ marginBottom: 12 }}>← Back</button>
      <h1>{brand.name}</h1>
      {brand.image_url && <img src={brand.image_url} alt={brand.name} style={{ maxWidth: 240, display: "block", marginBottom: 12 }} />}
      <p>Browse products for this brand:</p>
      <a href={`/shop?brand_id=${brand.id}`} style={{ color: "#0f62fe" }}>Go to Shop</a>
    </section>
  );
}
